<template>
  <div>
    <b-card class="body-card" header-bg-variant="light">
      <b-card-header class="card-header-wrapper">
        <div class="title-wrapper">
          <span class="ndc-title-header">
            ImpaxRx PAP Drug Management
            <span class="sub-header">&nbsp;> By NDC</span>
          </span>
          <div class="btn-filter-wrapper">
            <b-button @click="clearFilters" class="btn-filters">Clear filters</b-button>
            <b-button @click="exportToCsv" class="btn-csv">Export to CSV</b-button>
          </div>
          <download-csv
            v-if="ndcDetailsRecords"
            style="visibility :hidden"
            name="ndcDetailsRecords.csv"
            ref="exportCsv"
            :data="ndcDetailsRecords"
          >Export to CSV</download-csv>
        </div>
      </b-card-header>
      <b-card-body class="card-body-wrapper">
        <b-card class="card-wrapper" header-bg-variant="dark" header="Drug NDC Details">
          <grid
            :has-clear="false"
            has-pagination
            grid-id="ndcs-details-grid"
            :fields="fields"
            :items="ndcDetailsRecords"
            :filters="filtersObjArr"
            :get-items-function="getNDCsDetailsRecords"
            :total-rows="ndcDetailsPaging.totalItems"
            :current-page="ndcDetailsPaging.pageNumber"
            :per-page="ndcDetailsPaging.pageSize"
            :sort-by="ndcDetailsPaging.sortBy"
            :no-records="'No associated records found'"
            :sort-order="ndcDetailsPaging.sortOrder"
            ref="ndcsDetailsGridRef"
          ></grid>
        </b-card>
      </b-card-body>
    </b-card>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import Grid from '@/shared/components/Grid';
import { IRX_ELIGIBLE_OPTIONS } from '@/shared/constants';

export default Vue.extend({
  name: 'NDCDetails',
  components: {
    Grid
  },
  data() {
    return {
      fields: [
        { key: 'brand', label: 'Brand' },
        { key: 'iRxEligible', label: 'ImpaxPAP' },
        { key: 'ndC11', label: 'NDC11', tdClass: 'txt-link' },
        { key: 'ndcPackageCode', label: 'NDCPACKAGECODE' },
        { key: 'productNDC', label: 'PRODUCTNDC' },
        { key: 'ndC9', label: 'NDC9' },
        { key: 'ndcDescription', label: 'NDCDescription' }
      ],
      filtersObjArr: [
        { type: 'search', name: 'Brand', fieldName: 'brand' },
        {
          type: 'select',
          name: 'ImpaxPAP',
          fieldName: 'iRxEligible',
          value: '',
          width: '100px',
          options: [
            { value: '', text: 'Select' },
            { value: IRX_ELIGIBLE_OPTIONS.ALL, text: 'All' },
            { value: IRX_ELIGIBLE_OPTIONS.YES, text: 'Yes' },
            { value: IRX_ELIGIBLE_OPTIONS.NO, text: 'No' }
          ]
        },
        { type: 'search', name: 'NDC', fieldName: 'ndC11' }
      ]
    };
  },
  computed: {
    ...mapState('ndcDetails', ['ndcDetailsRecords', 'ndcDetailsPaging'])
  },
  methods: {
    ...mapActions('ndcDetails', ['getNDCsDetailsRecords']),

    async clearFilters() {
      await this.$refs['ndcsDetailsGridRef'].onClearSearch();
    },

    exportToCsv() {
      this.$refs.exportCsv.$el.click();
    },

    async getNDCsDetailsData(pagingData) {
      await this.getNDCsDetailsRecords(pagingData);
    }
  }
});
</script>
<style scoped>
.ndc-title-header {
  font-size: 1.2rem;
  grid-column: 1/3;
  align-self: center;
}
</style>
